import React, { useRef, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CommentCarousel.css";
import { useLanguage } from "./LanguageContext";

const shuffleArray = (arr) => {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const CommentCarousel = () => {
  const carouselRef = useRef(null);
  const { t } = useLanguage();

  const comments = t("comments");
  const shuffledComments = useMemo(() => shuffleArray(comments), [comments]);

  return (
    <section id="CommentCarousel" className="py-5 text-center minghie">
      <div className="container position-relative">
        <h2 className="h2 fw-bold mb-4">{t("commentTitle")}</h2>
        
        <div
          id="commentCarousel"
          className="carousel carousel-dark slide"
          ref={carouselRef}
          data-bs-ride="false" 
        >
          {/* Aggiunta la classe custom-carousel-inner per bloccare l'altezza */}
          <div className="carousel-inner px-5 custom-carousel-inner">
            {shuffledComments.map((comment, index) => {
              
              // LOGICA DI ADATTAMENTO TESTO: 
              // Seleziona la classe in base a quanti caratteri ha il commento
              let textSizeClass = "quote-normal";
              if (comment.text.length > 250) {
                textSizeClass = "quote-small";
              } else if (comment.text.length > 150) {
                textSizeClass = "quote-medium";
              }

              return (
                <div
                  className={`carousel-item w-100 h-100 ${index === 0 ? "active" : ""}`}
                  key={index}
                >
                  <div className="comment-card-wrapper mx-auto">
                    <p className={`feedback-quote ${textSizeClass}`}>
                      “{comment.text}”
                    </p>
                    <p className="comment-card-author mb-0">- {comment.author}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="carousel-control-prev custom-comment-arrow"
            type="button"
            data-bs-target="#commentCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Precedente</span>
          </button>
          <button
            className="carousel-control-next custom-comment-arrow"
            type="button"
            data-bs-target="#commentCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Successivo</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CommentCarousel;